/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DownpaymentCc/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function DownpaymentCc({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditSteps/DownpaymentCc"
  
}) {
let rulesetDownpaymentPaymentMethodsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'downpayment_payment_methods',
})
let constantData = 'credit_card'
let aggregateData = fromAggregate.includes(rulesetDownpaymentPaymentMethodsValueData, constantData)
let onChange = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="ruleset.downpayment_payment_methods"
 data="'credit_card'"
 aggregate="/Data/aggregate.js includes"
 value={aggregateData}
 onChange={onChange}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="CC"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}